import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Header from "./Header";
import Sidebar from "./Sidebar";
import PropTypes from "prop-types";
import VHeader from "../../components/Layout/Header";

/**
 * Component for rendering the layout of a logged-in user.
 * @param {Object} props - Props for the LoggedInLayout component.
 * @param {string} props.logo - Logo source.
 * @param {Node} props.children - Content to be rendered inside the layout.
 * @param {string} props.img - Image source.
 * @param {string} props.buttonLabel - Label for the button.
 * @param {string} props.pageTitle - Title of the page.
 * @returns {JSX.Element} - Rendered component.
 */
const LoggedInLayout = ({
  logo,
  links,
  children,
  img,
  userInitials,
  buttonLabel,
  pageTitle,
  isActivation,
  isVhlogin,
  vitalityLayout
}) => {
  return (
    <>
      {isVhlogin && <VHeader />}
      {/* Main container */}
      <Container className={`${vitalityLayout ? "vitality-layout-container" : "vh-100"}`} fluid>
        {/* Row for layout */}
        <Row className="h-100">
          {/* Sidebar column */}
          {!vitalityLayout &&
            <Col className="sidebar-container">
              {/* Sidebar component */}
              <Sidebar
                buttonLabel={buttonLabel}
                isActivation={isActivation}
                links={links}
                logo={logo}
              />
            </Col>
          }
          {/* Main content column */}
          <Col className={`${vitalityLayout ? "p-0 vitality-main-content" : "main-content"}`} lg={vitalityLayout ? 12 : 10} md={vitalityLayout ? 12 : 9} xs={vitalityLayout ? 12 : 9}>
            {/* Header component */}
            {!vitalityLayout &&
              <Header
                img={img}
                isActivation={isActivation}
                title={pageTitle}
                userInitials={userInitials}
              />
            }
            {/* Main content */}
            <main>{children}</main>
          </Col>
        </Row>
      </Container>
    </>
  );
};

LoggedInLayout.propTypes = {
  logo: PropTypes.string,
  children: PropTypes.node,
  img: PropTypes.string,
  pageTitle: PropTypes.string,
  links: PropTypes.array,
  userInitials: PropTypes.string,
  buttonLabel: PropTypes.string,
  isActivation: PropTypes.bool,
};

export default LoggedInLayout;
